import React from "react";
import { Button, Modal } from "@opendate-app/setlist";

const CancelWorkflowExecutionsModal = ({
  open,
  onClose,
  onContinue,
  onCancel,
  inProgressCount,
  changeDescription = "making this change",
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      type="warning"
      title="Workflows in Progress"
      closeOnBackdrop={false}
      footer={(
        <>
          <Button variant="secondary" onClick={onContinue}>Allow to Continue</Button>
          <Button variant="destructive" onClick={onCancel}>Cancel Workflows</Button>
        </>
      )}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12, fontSize: 14, lineHeight: "20px", color: "var(--sl-text-tertiary)" }}>
        <div>
          There {inProgressCount === 1 ? 'is' : 'are'} <strong>{inProgressCount}</strong> workflow{inProgressCount === 1 ? '' : 's'} currently in progress for this automation.
        </div>
        <div>
          Before {changeDescription}, would you like to cancel the in-progress workflows or allow them to continue?
        </div>
      </div>
    </Modal>
  );
};

export default CancelWorkflowExecutionsModal;
